// This file is generated by pnpm icons:generate. Do not edit.

import {VerifiedCheck as CanonicalVerifiedCheck} from './brands/VerifiedCheck'

/** @deprecated Import VerifiedCheck from `#/components/icons/brands/VerifiedCheck` instead. */
export const VerifiedCheck = CanonicalVerifiedCheck
